import { useCallback } from 'react';
import type { ObjectType } from '../../../shared/types';
import { useConfigurationStore } from '../../../shared/stores/useConfigurationStore';

export interface UseObjectTypeManagementArgs {
  handleNodeSelect: (type: string, name?: string, options?: { persist?: boolean }) => void;
  objectTypeOptions: ObjectType[];
  selectedNodeName: string | null | undefined;
}

export interface UseObjectTypeManagementResult {
  handleAddObjectType: (objectTypeName: string) => void;
  handleDeleteObjectType: (objectTypeName: string) => void;
}

export function useObjectTypeManagement({
  handleNodeSelect,
  objectTypeOptions,
  selectedNodeName,
}: UseObjectTypeManagementArgs): UseObjectTypeManagementResult {
  const addObjectType = useConfigurationStore((state) => state.addObjectType);
  const removeObjectType = useConfigurationStore((state) => state.removeObjectType);

  const handleAddObjectType = useCallback((objectTypeName: string) => {
    const newObjectType: ObjectType = {
      name: objectTypeName,
      attributes: [],
    };

    addObjectType(newObjectType);
    handleNodeSelect('objectType', objectTypeName);
  }, [addObjectType, handleNodeSelect]);

  const handleDeleteObjectType = useCallback((objectTypeName: string) => {
    removeObjectType(objectTypeName);
    if (selectedNodeName === objectTypeName) {
      const remainingTypes = objectTypeOptions.filter((obj) => obj.name !== objectTypeName);
      if (remainingTypes.length > 0) {
        handleNodeSelect('objectType', remainingTypes[0].name);
      } else {
        handleNodeSelect('components');
      }
    }
  }, [handleNodeSelect, objectTypeOptions, removeObjectType, selectedNodeName]);

  return { handleAddObjectType, handleDeleteObjectType };
}
